import { Input } from '@/components/ui';

interface SearchFilterBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

export function SearchFilterBar({ searchQuery, onSearchChange }: SearchFilterBarProps) {
  return (
    <div className="min-w-[18rem]">
      <Input
        placeholder="Filter by document ID prefix…"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="w-full"
      />
    </div>
  );
}
